// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".notifications .alert{position:fixed;z-index:10000}.notifications .alert[data-notify=container]{max-width:500px}.notifications .alert.center{margin:0 auto}.notifications .alert.left{left:20px}.notifications .alert.right{right:20px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
